import {Component, OnInit, PLATFORM_ID} from '@angular/core';
import {RouterLink, RouterOutlet} from "@angular/router";
import {
    SubdomainStreamerHeaderComponent
} from "@cybfed/new-ui/components/navigations/header/subdomain-streamer-header/subdomain-streamer-header.component";
import {NgClass, NgIf} from "@angular/common";
import {ConfigurationSideBarComponent} from "../configuration-side-bar/configuration-side-bar.component";
import {PageBuilderStore} from "./page-builder.store";
import {CustomInputComponent} from "@cybfed/shared/components/custom-input/custom-input.component";
import {FileUploaderComponent} from "@cybfed/shared/components/file-uploader/file-uploader.component";
import {ModalComponent} from "@cybfed/shared/components/modal/modal.component";
import {appConstants} from "@cybfed/constants";
import {TranslateModule} from "@ngx-translate/core";
import {MediaComponent} from "@cybfed/ui-lib/forms/image-input/media-gallery/media.component";
import {TreeViewComponent} from "@white-label/components/tree-view/tree-view.component";
import {
    DefaultHeaderComponent
} from "@white-label/components/page-builder/components/headers/default/default-header.component";
import {
    DefaultFooterComponent
} from "@white-label/components/page-builder/components/footers/dedault/default-footer.component";
import {LayoutTypes, NavigationModel} from "@white-label/components/page-builder/models/navigation.model";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {ThemeService} from "@white-label/components/page-builder/theme-settings-form/themes/theme.service";
import * as defaultTheme from "./theme-settings-form/themes/default_theme.json"
import {
    HorizontalLogoCenterHeaderComponent
} from "@white-label/components/page-builder/components/headers/horizontal-logo-center/horizontal-logo-center-header.component";
import {HttpService} from "@cybfed/core/services/http.service";
@Component({
    selector: 'app-admin-page-builder-layout',
    standalone: true,
    imports: [
        RouterLink,
        SubdomainStreamerHeaderComponent,
        RouterOutlet,
        ConfigurationSideBarComponent,
        NgClass,
        CustomInputComponent,
        FileUploaderComponent,
        ModalComponent,
        NgIf,
        TranslateModule,
        MediaComponent,
        MediaComponent,
        TreeViewComponent,
        DefaultHeaderComponent,
        DefaultFooterComponent,
        HorizontalLogoCenterHeaderComponent
    ],
    providers: [
        PageBuilderStore, HttpService
    ],
    templateUrl: './page-builder-layout.component.html'
})
export class PageBuilderLayoutComponent  implements OnInit{
    big = false;

    bannerSizes: any = appConstants.IMAGESIZES

    constructor(public pageBuilderStore: PageBuilderStore,
                public mainStore: MainStoreService,
                public themeService: ThemeService,
    ) {
        if(!this.mainStore?.whiteLabel?.header){
            this.mainStore.whiteLabel.header = new NavigationModel();
        }
        if(!this.mainStore?.whiteLabel?.footer){
            this.mainStore.whiteLabel.footer = new NavigationModel();
        }
        if(!this.mainStore?.whiteLabel?.styling){
            this.mainStore.whiteLabel.styling = defaultTheme;
        }
    }

    ngOnInit(): void {
        this.themeService.applyTheme(this.mainStore?.whiteLabel?.styling);
    }

    protected readonly LayoutTypes = LayoutTypes;
}
